import { FC } from 'react';
import { navigate, PageProps } from 'gatsby';
import { useQueryClient } from 'react-query';
import { MedusaLineItem, MedusaProductVariant } from 'lib/home/generated/types/api';
import { useUpdateCurrentOrderLineItemMutation } from 'lib/home/generated/queries';
import { RegistrationRouteMap, RegistrationStep } from '../../store';
import { GettingStartedContent, GettingStartedLayout, MealSwapWithFilters } from '../../components';
import { swapMealInCurrentOrder } from '../../util/helpers/swap';

interface MealSwapState {
  item: MedusaLineItem;
}

interface MealSwapPageProps {
  item: MedusaLineItem;
}

const MealSwapPage: FC<MealSwapPageProps> = ({ item }) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading, isSuccess } = useUpdateCurrentOrderLineItemMutation();

  const handleSwap = (cartItemId: string, variant: MedusaProductVariant, handleSuccess?: () => void) => {
    mutate(
      { input: { id: cartItemId, variant_id: variant.id } },
      {
        onSuccess: data => {
          const {
            updateCurrentOrderLineItem: { medusa_cart }
          } = data;

          swapMealInCurrentOrder(queryClient, medusa_cart);
          handleSuccess && handleSuccess();
          navigate(RegistrationRouteMap.customizeBox);
        }
      }
    );
  };

  return (
    <GettingStartedLayout step={RegistrationStep.swapMeal}>
      <GettingStartedContent>
        <MealSwapWithFilters
          isLoading={isLoading}
          isSuccess={isSuccess}
          item={item}
          onSwap={handleSwap}
          onBackClick={() => navigate(RegistrationRouteMap.customizeBox)}
        />
      </GettingStartedContent>
    </GettingStartedLayout>
  );
};

const MealSwapPageWrapper: FC<PageProps<object, object, MealSwapState>> = ({ location }) => {
  const item = location.state?.item;

  if (!item && typeof window !== `undefined`) {
    navigate(RegistrationRouteMap.customizeBox);
    return null;
  }

  return <MealSwapPage item={item} />;
};

export default MealSwapPageWrapper;
